import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-699ce01a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "update-developer-form mb--20" }

import { ErrorsType, ParamsDataType } from '@/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'UpdateFormFirst',
  props: /*#__PURE__*/_mergeModels({
    errors: {},
    isSaveLoading: { type: Boolean }
  }, {
    "paramsData": {},
    "paramsDataModifiers": {},
    "v$": {},
    "v$Modifiers": {},
  }),
  emits: /*#__PURE__*/_mergeModels(['validationErrorsHandlerByKey', 'inputTouch', 'focus', 'save'], ["update:paramsData", "update:v$"]),
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
// eslint-disable-next-line no-undef
const paramsData = _useModel<ParamsDataType>(__props, 'paramsData');
// eslint-disable-next-line no-undef
const v$ = _useModel<ParamsDataType>(__props, 'v$');

return (_ctx: any,_cache: any) => {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_checkbox_input = _resolveComponent("base-checkbox-input")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_form = _resolveComponent("base-form")!

  return (_openBlock(), _createBlock(_component_base_form, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_base_input, {
          modelValue: paramsData.value['value'].value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((paramsData.value['value'].value) = $event)),
          error: _ctx.errors['value'],
          invalid: !!_ctx.errors['value'],
          height: "36",
          hideArrows: "",
          label: "Название категории",
          type: "text",
          onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('validationErrorsHandlerByKey', 'value'))),
          onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('focus', 'value'))),
          onInput: v$.value['value']?.$touch
        }, null, 8, ["modelValue", "error", "invalid", "onInput"]),
        _createVNode(_component_base_checkbox_input, {
          modelValue: paramsData.value['public'].value,
          "onUpdate:modelValue": [
            _cache[3] || (_cache[3] = ($event: any) => ((paramsData.value['public'].value) = $event)),
            v$.value['public']?.$touch
          ],
          height: "36",
          label: "Публиковать",
          onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('validationErrorsHandlerByKey', 'public')))
        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
        (paramsData.value['is_missed'] !== undefined)
          ? (_openBlock(), _createBlock(_component_base_checkbox_input, {
              key: 0,
              modelValue: paramsData.value['is_missed'].value,
              "onUpdate:modelValue": [
                _cache[5] || (_cache[5] = ($event: any) => ((paramsData.value['is_missed'].value) = $event)),
                v$.value['is_missed']?.$touch
              ],
              height: "36",
              label: "Пропустить",
              onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('validationErrorsHandlerByKey', 'is_missed')))
            }, null, 8, ["modelValue", "onUpdate:modelValue"]))
          : _createCommentVNode("", true),
        _createVNode(_component_base_button, {
          loading: _ctx.isSaveLoading,
          "all-block-width": "",
          height: "40",
          text: "Сохранить",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('save')))
        }, null, 8, ["loading"])
      ])
    ]),
    _: 1
  }))
}
}

})